import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-view-single-property',
  templateUrl: './view-single-property.component.html',
  styleUrls: ['./view-single-property.component.css']
})
export class ViewSinglePropertyComponent implements OnInit {

  viewPropertyForm: FormGroup;
  recievedProperty: any;
  isLoading: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private fb: FormBuilder) { 
    this.viewPropertyForm = this.fb.group({
      name: [''],
      status: [''],
      type: [''],
      industry: [''],
      noOfDays: [''],
      onSiteAttendance: [''],
      eventSite: [''],
      category: [''],
      description: ['']
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.queryParams.subscribe(params => {

      console.log("recieved property: ", params);
      this.recievedProperty = params;

    });

    const formValues = {
      name: [this.recievedProperty.name],
      status: [this.recievedProperty.status],
      type: [this.recievedProperty.type],
      industry: [this.recievedProperty.industry],
      noOfDays: [this.recievedProperty.noOfDays],
      onSiteAttendance: [this.recievedProperty.onSiteAttendance],
      eventSite: [this.recievedProperty.eventSite],
      category: [this.recievedProperty.category],
      description: [this.recievedProperty.description]
    };
    
    setTimeout(() => {
      this.isLoading = false;
      this.viewPropertyForm = this.fb.group(formValues);  //populate form with current values
    }, 1000);
    

  }

  onEditProperty(){

    this.router.navigate(
      ['/private-space/edit-property'],
      {
        relativeTo: this.route,
        queryParams: this.recievedProperty,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

}
